/** Support inbox used for plan-upgrade and quota-lift requests. */
export const SUPPORT_EMAIL = "support@medblocks.com";
